module.exports = __webpack_public_path__ + "static/garda_main_2-74aae303ce2e396a07ab2f7d2544fddc.png";